import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles<string, {}, Theme>((theme: Theme) => ({
  spacer: {
    flex: 1,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.marginBase,

    marginTop: theme.marginBase * 2,
    [theme.media.mobile]: {
      justifyContent: 'center',
    },
  },
}));

interface Props {
  children: React.ReactNode;
}

export const OnboardingButtons = ({ children }: Props) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.spacer} />
      <div className={classes.container}>{children}</div>
    </>
  );
};
